var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C24.9826 0 16.3346 3.58213 9.95837 9.95837C3.58213 16.3346 0 24.9826 0 34C0 43.0174 3.58213 51.6654 9.95837 58.0416C16.3346 64.4179 24.9826 68 34 68C43.0174 68 51.6654 64.4179 58.0416 58.0416C64.4179 51.6654 68 43.0174 68 34C68 24.9826 64.4179 16.3346 58.0416 9.95837C51.6654 3.58213 43.0174 0 34 0V0ZM34 61.625C26.6734 61.625 19.6469 58.7145 14.4662 53.5338C9.28548 48.3531 6.375 41.3266 6.375 34C6.375 26.6734 9.28548 19.6469 14.4662 14.4662C19.6469 9.28548 26.6734 6.375 34 6.375C41.3266 6.375 48.3531 9.28548 53.5338 14.4662C58.7145 19.6469 61.625 26.6734 61.625 34C61.625 41.3266 58.7145 48.3531 53.5338 53.5338C48.3531 58.7145 41.3266 61.625 34 61.625V61.625Z",
    fill: "#FF0404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 17L34 27.625L23.375 17L17 23.375L27.625 34L17 44.625L23.375 51L34 40.375L44.625 51L51 44.625L40.375 34L51 23.375L44.625 17Z",
    fill: "#FF0404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.c0eb2249c3b7f933ea4d3e55d22fa88a.svg";
export { ForwardRef as ReactComponent };